export enum UserRoles {
  Admin,
  SuperAdmin,
}

export enum UserStatus {
  Available = 'Available',
  Break = 'Break',
  OutOfOffice = 'Out Of Office',
  Busy = 'Busy',
}

export enum CovenantLiteType {
  Yes = 'Yes',
  No = 'No',
  Springing = 'Springing',
}

export enum DebtType {
  FirstLienOne = '1st Lien - 1',
  FirstLienTwo = '1st Lien - 2',
  FirstLienThree = '1st Lien - 3',
  FirstLienFour = '1st Lien - 4',
  FirstLienFive = '1st Lien - 5',
  SecondLienOne = '2nd Lien - 1',
  SecondLienTwo = '2nd Lien - 2',
  SecondLienThree = '2nd Lien - 3',
  SecondLienFour = '2nd Lien - 4',
  SecondLienFive = '2nd Lien - 5',
  OtherDebtOne = 'Other debt - 1',
  OtherDebtTwo = 'Other debt - 2',
  OtherDebtThree = 'Other debt - 3',
  OtherDebtFour = 'Other debt - 4',
  OtherDebtFive = 'Other debt - 5',
  Abl = 'ABL',
  PriorityDebt = 'Priority Debt',
  Revolver = 'Revolver',
}

export enum MoodysLienRating {
  Aaa = 'Aaa',
  Aa1 = 'Aa1',
  Aa2 = 'Aa2',
  Aa3 = 'Aa3',
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  Baa1 = 'Baa1',
  Baa2 = 'Baa2',
  Baa3 = 'Baa3',
  Ba1 = 'Ba1',
  Ba2 = 'Ba2',
  Ba3 = 'Ba3',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  Caa1 = 'Caa1',
  Caa2 = 'Caa2',
  Caa3 = 'Caa3',
  CaC = 'Ca-C',
  NR = 'NR',
  NA = 'N/A',
}

export enum SAndPLienRating {
  AAA = 'AAA',
  AAPlus = 'AA+',
  AA = 'AA',
  AAMinus = 'AA-',
  APlus = 'A+',
  A = 'A',
  AMinus = 'A-',
  BBBPlus = 'BBB+',
  BBB = 'BBB',
  BBBMinus = 'BBB-',
  BBPlus = 'BB+',
  BB = 'BB',
  BBMinus = 'BB-',
  BPlus = 'B+',
  B = 'B',
  BMinus = 'B-',
  CCCPlus = 'CCC+',
  CCC = 'CCC',
  CCCMinus = 'CCC-',
  CC = 'CC',
  C = 'C',
  D = 'D',
  SD = 'SD',
  NR = 'NR',
  NA = 'N/A',
}

export enum CfrOutlookType {
  Positive = 'Positive',
  Negative = 'Negative',
  Stable = 'Stable',
  Developing = 'Developing',
  NM = 'NM',
}

export enum CfrWatchType {
  Positive = 'Positive',
  Negative = 'Negative',
  Developing = 'Developing',
  NM = 'NM',
}

export enum NewsEarningsFilter {
  News = 'News',
  EarningsRelease = 'Earnings Release',
  LenderCall = 'Lender Call',
  LenderPresentations = 'Lender Presentations',
  Amendments = 'Amendments',
}

export enum NewsEarningsSort {
  All = 'all',
  LastXDays = 'lastxdays',
}

export enum DataSiteDocumentFilter {
  LastHour = 'lasthour',
  LastDay = 'lastday',
  LastWeek = 'lastweek',
  LastMonth = 'lastmonth',
}

export enum FinancialStatementType {
  BalanceSheet = 'BalanceSheet',
  CapitalStructure = 'CapitalStructure',
  CashFlow = 'CashFlow',
  IncomeStatement = 'IncomeStatement',
  SummaryFinancials = 'SummaryFinancials',
  KPIs = 'KPIs',
}

export enum CompanyStatementStatus {
  Draft = 'Draft',
  Live = 'Live',
}

export enum CompanyAnalytics {
  date = 'As of,',
  revenue = 'Revenue',
  grossProfit = 'Gross Profit',
  ebit = 'EBIT',
  ebitda = 'EBITDA',
  ebitdaAdjustments = 'EBITDA Adjustments',
  adjustedEbitda = 'Adjusted EBITDA',
  covenantEbitda = 'Covenant EBITDA',
  ocf = 'OCF',
  capitalExpenditures = 'Capital Expenditures (CapEx)',
  cash = 'Cash',
  abl = 'ABL',
  priorityDebt = 'Priority Debt',
  revolver = 'Revolver',
  firstLien1 = '1st Lien - 1',
  firstLien2 = '1st Lien - 2',
  firstLien3 = '1st Lien - 3',
  firstLien4 = '1st Lien - 4',
  firstLien5 = '1st Lien - 5',
  firstLienDebtGross = '1st Lien Debt',
  firstLienDebtNet = '1st Lien Debt, net',
  secondLien1 = '2nd Lien - 1',
  secondLien2 = '2nd Lien - 2',
  secondLien3 = '2nd Lien - 3',
  secondLien4 = '2nd Lien - 4',
  secondLien5 = '2nd Lien - 5',
  securedLienDebtGross = 'Secured Debt',
  securedLienDebtNet = 'Secured Lien Debt, net',
  otherDebt1 = 'Other debt - 1',
  otherDebt2 = 'Other debt - 2',
  otherDebt3 = 'Other debt - 3',
  otherDebt4 = 'Other debt - 4',
  otherDebt5 = 'Other debt - 5',
  totalDebtGross = 'Total Debt',
  totalDebtNet = 'Total Debt, net',
  interestExpense = 'Interest Expense',
  interestCoverage = 'Interest Coverage',
  interestCoverageAfterCapEx = 'Interest Coverage (After CapEx)',
  lineOfCreditSize = 'Committed Line of Credit',
  lineOfCreditAvailability = 'Available Line of Credit',
  availableLiquidity = 'Available Liquidity',
}

export enum ModalTypes {
  None = 0,
  PreviewModal = 1,
  ConfirmModal = 2,
}

export enum ClientDataSiteStage {
  Upload = 0,
  Verification = 1,
}

export enum IncomeStatement {
  date = 'As of',
  revenue = 'Revenue',
  grossProfit = 'Gross Profit',
  percentMargin = '% Margin',
  percentGrowth = '% Growth',
  ebit = 'EBIT',
  ebitda = 'EBITDA',
  depreciationAmortization = 'Depreciation and Amortization',
  ebitdaAdjustments = 'EBITDA Adjustments',
  percentOfSales = '% of Sales',
  percentOfEbitda = '% of EBITDA',
  adjustedEbitda = 'Adjusted EBITDA',
  covenantEbitda = 'Covenant EBITDA',
  ocf = 'OCF',
  capEx = 'Capital Expenditures (CapEx)',
  ocfCapEx = 'OCF-CapEx',
}

export enum CapitalStructureRowTitles {
  FirstLienDebt = 'First Lien Debt',
  FirstLienDebtNet = 'First Lien Debt, net',
  SecuredDebt = 'Secured Debt',
  SecuredDebtNet = 'Secured Debt, net',
  TotalDebt = 'Total Debt',
  TotalDebtNet = 'Total Debt, net',
  InterestCoverage = 'Interest Coverage',
  InterestCoverageCapEx = 'Interest Coverage (After CapEx)',
  Cash = 'Cash',
  CommittedCredit = 'Committed Line of Credit',
  AvailableCredit = 'Available Line of Credit ',
  AvailableLiquidity = 'Available Liquidity',
}

export enum CompanyCapitalStructureKeys {
  Ebitda = 'ebitda',
  FirstLienDebtGross = 'firstLienDebtGross',
  FirstLienDebtNet = 'firstLienDebtNet',
  SecuredDebtGross = 'securedDebtGross',
  SecuredDebtNet = 'securedDebtNet',
  TotalDebtGross = 'totalDebtGross',
  TotalDebtNet = 'totalDebtNet',
  InterestCoverage = 'interestCoverage',
  InterestCoverageAfterCapitalExpenditures = 'interestCoverageAfterCapitalExpenditures',
}

export enum CompanyTransactionDetailsKeys {
  TransactionDate = 'Transaction Date',
  TotalEnterpriseValue = 'Total Enterprise Value',
  RevenueAtBuyout = 'Revenue @ Buyout',
  ManagementAdjustedEbitdaAtBuyout = 'Mgmt. Adj. EBITDA @ Buyout',
  TotalEnterpriseValueByRevenue = 'TEV / Revenue',
  TotalEnterpriseValueByAdjustedManagementEbitda = 'TEV / Adj. Mgmt. EBITDA',
  NetDebt = 'Net Debt',
  NetDebtPercentageOfCap = 'Net Debt % of Cap',
  SponsorEquity = 'Sponsor Equity',
  RolloverEquity = 'Rollover Equity',
  TotalEquity = 'Total Equity',
  TotalEquityPercentageOfCap = 'Total Equity % of Cap',
  CumulativeDividends = 'Cumulative Dividends',
  ImpliedEquityAtRisk = 'Implied Equity "at risk"',
  SecuredDebt = 'Secured Debt',
  Cash = 'Cash',
}

export enum CompanyTransactionDetailsRowTitles {
  TransactionDate = 'Transaction Date',
  TotalEnterpriseValue = 'Total Enterprise Value',
  RevenueAtBuyout = 'Revenue @ Buyout',
  ManagementAdjustedEbitdaAtBuyout = 'Mgmt. Adj. EBITDA @ Buyout',
  TotalEnterpriseValueByRevenue = 'TEV / Revenue',
  TotalEnterpriseValueByAdjustedManagementEbitda = 'TEV / Adj. Mgmt. EBITDA',
  NetDebt = 'Net Debt',
  NetDebtPercentageOfCap = '% of Cap',
  SponsorEquity = 'Sponsor Equity',
  RolloverEquity = 'Rollover Equity',
  TotalEquity = 'Total Equity',
  TotalEquityPercentageOfCap = '% of Cap',
  CumulativeDividends = 'Cumulative Dividends',
  ImpliedEquityAtRisk = 'Implied Equity "at risk"',
  SecuredDebt = 'Secured Debt',
  Cash = 'Cash',
}

export enum DocumentState {
  Pending = 'Pending',
  Published = 'Published',
  Error = 'Error',
}

export enum ClientCompanyTaskType {
  Email = 'Email',
  MissingEmail = 'MissingEmail',
  Rogue = 'Rogue',
}

export enum AnalyticsMetrics {
  BottomQuartile = 'Bottom Quartile',
  Median = 'Median',
  TopQuartile = 'Top Quartile',
  TopDecile = 'Top Decile',
  BottomDecile = 'Bottom Decile',
}

export enum TranscriptionFileState {
  NotSubmitted = 'Not Submitted',
  Submitted = 'Submitted',
  Processing = 'Processing',
  Staged = 'Staged',
  Published = 'Published',
  Error = 'Error',
}

export enum ReplayType {
  Phone = 'Phone',
  Streaming = 'Streaming',
}

export enum TranscriptionContainer {
  Input = 'Input',
  Staged = 'Staged',
  Published = 'Published',
}

export enum TranscriptionStatus {
  Draft = 'Draft',
  Live = 'Live',
}

export enum KpiState {
  KpisNotYetReviewed = 'KpisNotYetReviewed',
  KpisNotVisible = 'KpisNotVisible',
  KpisVisible = 'KpisVisible',
}

export enum HelpCenterItemType {
  Document = 'Document',
  Video = 'Video',
  ExcelPlugin = 'ExcelPlugin',
}

export enum CompanyDocumentState {
  Pending = 'Pending',
  Published = 'Published',
  Error = 'Error',
  PendingRequiresApproval = 'PendingRequiresApproval',
  Deleted = 'Deleted',
}

export enum FinancialDocumentType {
  Other = 'Other',
  Q = 'Q',
  FYE = 'FYE',
}

export enum CompanyDocumentSubmissionType {
  Files = 'Files',
  Zip = 'Zip',
}

export enum ClientCompanyDeclarationStatus {
  Pending = 'Pending',
  ClientApproved = 'ClientApproved',
  Rejected = 'Rejected',
  BixbyApproved = 'BixbyApproved',
  Deleted = 'Deleted',
  None = 'None',
}

export enum ClientCompayBasisOfAccess {
  DataSiteAccess = 'DataSiteAccess',
  CloHoldingsAccess = 'CloHoldingsAccess',
}

export enum UserCompanyDeclarationStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected',
  Deleted = 'Deleted',
}

export enum DeclarationType {
  Public = 'Public',
  Private = 'Private',
}

export enum UserActivityEvent {
  DownloadCompanyDocument = 'DownloadCompanyDocument',
  DownloadFinancialTearsheetPrimerDocument = 'DownloadFinancialTearsheetPrimerDocument',
  ViewTransactionComps = 'ViewTransactionComps',
  ViewNewsEntry = 'ViewNewsEntry',
  UserLoggedIn = 'UserLoggedIn',
  ViewCompany = 'ViewCompany',
  ViewNews = 'ViewNews',
  ViewCompanyFinancialSheet = 'ViewCompanyFinancialSheet',
  ViewCompanyTranscripts = 'ViewCompanyTranscripts',
  ViewCompanyTranscriptEntry = 'ViewCompanyTranscriptEntry',
  DownloadCompanyTranscriptText = 'DownloadCompanyTranscriptText',
  DownloadCompanyTranscriptAudio = 'DownloadCompanyTranscriptAudio',
  ViewCompanyDocuments = 'ViewCompanyDocuments',
  ViewCompanyComps = 'ViewCompanyComps',
  ViewCompanyPai = 'ViewCompanyPai',
  DownloadNews = 'DownloadNews',
  DownloadFinancialModel = 'DownloadFinancialModel',
  ViewAnalytics = 'ViewAnalytics',
  ViewClos = 'ViewClos',
  ViewHistoricalDocuments = 'ViewHistoricalDocuments',
  UserLoggedInExcel = 'UserLoggedInExcel',
  ViewAnalysticsExcel = 'ViewAnalyticsExcel',
}

export enum Operator {
  Equals,
  GreaterThan,
  GreaterThanOrEqual,
  LessThan,
  LessThanOrEqual,
}

export enum PrivateEquitySponsorType {
  Majority = 'Majority',
  Minority = 'Minority',
  FiftyFiftySplit = 'FiftyFiftySplit',
  Plurality = 'Plurality',
  Other = 'Other',
}

export enum QuestionType {
  Checkbox = 'Checkbox',
  Dropdown = 'Dropdown',
  Radio = 'Radio',
  Text = 'Text',
  Textarea = 'Textarea',
  File = "File"
}

export enum QuestionConditionalAction {
  Show = 'Show',
  Hide = 'Hide',
}

export enum BasisOfAccess {
  DataSiteAccess = "DataSiteAccess",
  CloHoldingsAccess = "CloHoldingsAccess",
  PublicCompanyAccess = "PublicCompanyAccess",
}


export enum CloDealHoldingForBixbyIdMappingReviewNote {
  MultipleBixbyIds = 'MultipleBixbyIds',
  RBC_Barclays = 'RBC_Barclays'
}

export enum WorkflowManagementUploadToPortalState {
  Ready = "Ready",
  InProgress = "InProgress",
  Uploaded = "Uploaded",
  AwaitingClientReview = "AwaitingClientReview",
  Error = "Error"
}

export enum WorkflowManagementCommonState {
  InProgress = "InProgress",
  Completed = "Completed"
}

export enum DataSiteEmailTrackingGroupedRecordStatus {
  Received = "Received",
  PendingReview = "PendingReview",
  InProgress = "InProgress",
  DocsUploaded = "DocsUploaded",
  ContentPublished = "ContentPublished",
  OpsReview = "OpsReview",
  Complete = "Complete"
}